import { render, staticRenderFns } from "./ProcessReply.vue?vue&type=template&id=642992ce&scoped=true&"
import script from "./ProcessReply.vue?vue&type=script&lang=js&"
export * from "./ProcessReply.vue?vue&type=script&lang=js&"
import style0 from "./ProcessReply.vue?vue&type=style&index=0&id=642992ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642992ce",
  null
  
)

export default component.exports